// extracted by mini-css-extract-plugin
export default {"wrapper":"bT-z","availablePromoMessagesLabel":"cT-z","promoMessageList":"dT-z","promoMessage":"eT-z","appliedPromoMessage":"fT-z","promoMessageAmount":"gT-z"};